
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <div class="modal-header">
        <h4 class="modal-title">Modify Contact</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col-sm-6">
            <label for="modifyContactFirstName" [ngClass]="{required: requiredFields}">First Name</label>
            <input class="form-control" id="modifyContactFirstName" type="text" formControlName="firstName" name="firstName">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyContactLastName" [ngClass]="{required: requiredFields}">Last Name</label>
            <input class="form-control" id="modifyContactLastName" type="text" formControlName="lastName" name="lastName">
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="modifyContactEmailAddress">Email Address</label>
            <input class="form-control" id="modifyContactEmailAddress" type="text" formControlName="emailAddress" name="emailAddress">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyContactPhoneNumber" [ngClass]="{required: requiredFields}">Phone Number</label>
            <input class="form-control" id="modifyContactPhoneNumber" type="text" formControlName="phoneNumber" name="phoneNumber">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyContactPhoneNumber2">Phone Number 2</label>
            <input class="form-control" id="modifyContactPhoneNumber2" type="text" formControlName="phoneNumber2" name="phoneNumber2">
          </div>
          <div class="form-group col-sm-6">
            <label [for]="'contactLocale'">Locale</label>
            <select-contact-locale [inputId]="'contactLocale'" formControlName="locale" name="locale" [inputName]="'contactLocale'"></select-contact-locale>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
        <button class="btn btn-primary" type="submit" [disabled]="!contactForm.valid">Save</button>
      </div>
    </form>
  </div>
</div>